<template>
  <thead class="v-data-table-header">
    <tr>
      <th
        v-for="(header, ind) in headers"
        :colspan="header.hasColspan ? header.colSpan : 0"
        :rowspan="getRowSpan(header)"
        :class="header.class"
      >
        <div class="header-check" v-if="header.type == 'check'">
          <div class="check-cust table-hed-check">
            <span class="check-text" v-if="header.text">{{ header.text }}</span>
            <span>
              <v-checkbox
                @change="onCheck(header)"
                v-model="header.checked"
              ></v-checkbox>
            </span>
          </div>
        </div>
        <div v-else-if="header.type == 'blank'">&nbsp;</div>
        <div
          v-else-if="header.type == 'button'"
          class="header-btn"
          :class="header.class"
        >
          <v-btn
            @click="onButtonClick(header)"
            class="right-btn cust-btn"
            color="primary"
            >{{ header.text }}</v-btn
          >
        </div>
        <div
          v-else-if="header.type == 'icon-button'"
          class="header-btn"
          :class="header.class"
        >
          <v-btn
            color="transparent"
            :class="header.class"
            depressed
            @click="onButtonClick(header)"
          >
            <v-img src="../assets/img/download.svg" width="26" height="26"></v-img>
          </v-btn>
        </div>
        <div v-else-if="header.type == 'dropdown'" class="drop-down">
          <div class="show-drop-down">
            <div class="field-data">
              <v-select
                :items="header.options"
                :label="header.text"
                hide-details
                dense
                solo
                v-model="selectedItems"
                @change="onSelect(header)"
                class="min-90"
              ></v-select>
            </div>
          </div>
        </div>
        <div
          v-else-if="header.type == 'multidropdown'"
          class="drop-down multiple-select"
        >
          <multi-select
            :allText="header.allText"
            :items="header.options"
            :label="header.text"
            :info="header"
            :onChange="onMultipleSelect"
            :widthcss="header.widthcss"
            class="fix-150"
          ></multi-select>
        </div>
        <div
          v-else
          :class="{
            'table-header-section': true,
            sortable: true,
            asc: isAscending(header.value),
            desc: isDescending(header.value),
          }"
        >
          <span v-html="header.text"></span>
          <button
            v-if="!header.hideSort"
            @click="changeSort(header)"
            class="custom-sort-icon-filled"
          >
            <!-- <span v-if="orderBy.order === 'DESC' && orderBy.field == header.value" class="desc-sort"></span> -->
            <!-- <span v-else-if="orderBy.order === 'ASC' && orderBy.field == header.value" class="asc-sort"></span> -->
            <span
              v-if="orderBy.field == header.value"
              :class="orderBy.order === 'DESC' ? 'desc-sort' : 'asc-sort'"
            ></span>
            <span v-else class="default-sort"></span>
          </button>
        </div>
      </th>
    </tr>
    <tr class="tr-II">
      <template v-for="(h, headerIndex) in headers">
        <template v-if="h.hasColspan">
          <th
            v-for="(col, idx) in h.cols"
            :key="col + idx + headerIndex"
            class="text-center btm-br"
          >
            {{ col }}
          </th>
        </template>
      </template>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "tableHeader",
  props: ["headers", "onHeaderAction", "onSortChange", "orderBy"],
  data() {
    return {
      checkbox: "",
      sortOrder: "",
      selectedItems: null,
    };
  },
  mounted() {},
  methods: {
    onCheck(header) {
      if (this.onHeaderAction) {
        this.onHeaderAction({
          header,
          data: { checked: header.checked },
        });
      }
    },
    onButtonClick(header) {
      if (this.onHeaderAction) {
        this.onHeaderAction({ header, data: {} });
      }
    },
    onMultipleSelect(selectedItems, { info }) {
      if (this.onHeaderAction) {
        this.onHeaderAction({
          header: info,
          data: { selectedItems: selectedItems },
        });
      }
    },
    onSelect(headers) {
      if (this.onHeaderAction) {
        this.onHeaderAction({
          headers,
          data: { selectedItem: this.selectedItems },
        });
      }
    },
    changeSort(header) {
      if (this.orderBy) {
        this.orderBy.order = this.orderBy.order === "ASC" ? "DESC" : "ASC";
        this.orderBy.field = header.value;
      }
      if (this.onSortChange) {
        this.onSortChange({
          header,
          action: "sort",
          data: { orderBy: this.orderBy },
        });
      }
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd.tabDetails && crd.tabDetails[crd.selectedTab])
        crd.tabDetails[crd.selectedTab].orderBy = this.orderBy;
      this.setRouteDetails(crd);
    },
    getRowSpan(header) {
      if (header && header.hasColspan === undefined) {
        return 1;
      } else if (header.hasColspan) {
        return 1;
      } else {
        return 2;
      }
    },
  },
  mounted() {},
  computed: {
    isAscending: function(state) {
      return (name) =>
        this.orderBy &&
        name === this.orderBy.field &&
        this.orderBy.order === "ASC";
    },
    isDescending: function(state) {
      return (name) =>
        this.orderBy &&
        name === this.orderBy.field &&
        this.orderBy.order === "DESC";
    },
  },
};
</script>
